var Zo,
    ea = 768,
    ta = 992,
    na = 30,
    ra = 20;
 
function za(e) {
    return function(e) {
        if (Array.isArray(e)) return Da(e)
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }(e) || function(e, t) {
        if (!e) return;
        if ("string" == typeof e) return Da(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Da(e, t)
    }(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }()
}
 function Da(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
    return r
}
var eMenu = {
    megaMenu: document.querySelector("[data-mega-menu]"),
    backBtn: document.querySelectorAll("[data-mega-menu-back]"),
    parentLinks: document.querySelectorAll("[data-mega-menu-show-children]"),
    links: document.querySelectorAll("[data-mega-menu-link]"),
    openBtn: document.querySelectorAll("[data-mega-menu-open]"),
    closeBtn: document.querySelectorAll("[data-mega-menu-close]"),
},
tMenu = {
    levels: ["mega-menu--level-3", "mega-menu--level-2", "mega-menu--level-1"],
    base: "mega-menu",
    show: "mega-menu--show",
    activeLevels: ["mega-menu__level-2--active", "mega-menu__level-3--active"],
    activeLinks: ["mega-menu__top-link--active", "mega-menu__child-link--active"],
    childLinkActive: "mega-menu__child-link--active",
},
n = ".mega-menu__level-2--active, .mega-menu__level-3--active",
r = ".mega-menu__top-link--active, .mega-menu__child-link--active",
i = function (n) {
    var r;
    (r = eMenu.megaMenu.classList).remove.apply(r, za(tMenu.levels)), eMenu.megaMenu.classList.add("".concat(tMenu.base, "--").concat(n));
},
o = function () {
    document.querySelectorAll(n).forEach(function (e) {
        var n;
        (n = e.classList).remove.apply(n, za(tMenu.activeLevels));
    });
},
a = function (evv) {
  eMenu.megaMenu.classList.add(tMenu.show), (document.body.style.overflow = "hidden");
    document.body.classList.add('menu-new-open');
},
s = function () {
    var n;
    o(),
        document.querySelectorAll(r).forEach(function (e) {
            var n;
            (n = e.classList).remove.apply(n, za(tMenu.activeLinks));
        }),
        (n = eMenu.megaMenu.classList).remove.apply(n, [tMenu.show].concat(za(tMenu.levels))),
        (document.body.style.overflow = "");
        document.body.classList.remove('menu-new-open');
        document.body.classList.remove('mobile-help-menu');
},
l = function (e) {
    e.currentTarget.dataset.megaMenuBack && i(e.currentTarget.dataset.megaMenuBack);
},
u = function (e) {
    var n = e.currentTarget,
        r = n.dataset.megaMenuShowChildren,
        o = "[data-mega-menu-".concat(r, "]"),
        a = "".concat(tMenu.base, "__").concat(r, "--active"),
        s = n.parentElement.querySelector(o),
        l = document.querySelectorAll(".".concat(a));
    e.preventDefault(),
        l.forEach(function (e) {
            return e.classList.remove(a);
        }),
        s.classList.add(a),
        i(r);
  
    if (e.target.classList.contains('helpclick')) {
      document.body.classList.add('mobile-help-menu');
    } else {
      document.body.classList.remove('mobile-help-menu');      
    }
},
c = function (e) {
    if (window.innerWidth >= ea) {
        var n = e.currentTarget,
            r = JSON.parse(n.dataset.megaMenuLink).currentLevel,
            a = JSON.parse(n.dataset.megaMenuLink).currentLinkType,
            s = (function (e, t) {
                for (var n = e.parentElement; !(n.matches || n.matchesSelector).call(n, t); ) n = n.parentElement;
                return n;
            })(e.currentTarget, ".".concat(tMenu.base, "__").concat(r)),
            l = "".concat(tMenu.base, "__").concat(r, "--active"),
            u = "".concat(tMenu.base, "__").concat(a, "--active"),
            c = document.querySelectorAll(".".concat(tMenu.childLinkActive)),
            f = document.querySelectorAll(".".concat(u));
        if ((o(), window.innerWidth >= ea && e.currentTarget.dataset.megaMenuShowChildren)) {
            var d = n.dataset.megaMenuShowChildren,
                p = "[data-mega-menu-".concat(d, "]"),
                h = "".concat(tMenu.base, "__").concat(d, "--active"),
                m = n.parentElement.querySelector(p);
            e.preventDefault(), m.classList.add(h), i(d);
        } else i(r);
        f.forEach(function (e) {
            return e.classList.remove(u);
        }),
            c.forEach(function (e) {
                return e.classList.remove(tMenu.childLinkActive);
            }),
            n.classList.add(u),
            s.classList.add(l);
    }
};
eMenu.backBtn.forEach(function (e) {
    e.addEventListener("click", l);
}),
eMenu.parentLinks.forEach(function (e) {
    e.addEventListener("touchend", u);
}),
eMenu.parentLinks.forEach(function (e) {
  var newWindowWidth = $(window).width();
  if (newWindowWidth < 950) {
    e.addEventListener("click", u);
  }
}),
eMenu.links.forEach(function (e) {
    e.addEventListener("mouseenter", c);
}),
eMenu.openBtn.forEach(function (e) {
    e.addEventListener("click", a);
}),
eMenu.closeBtn.forEach(function (e) {
    e.addEventListener("click", s);
});